<template>
  <div ref="tray" class="tray">
    <div class="tray-header">
      <div class="tray-header-actions">
        <div class="pull-left">
          {{ heading }}
        </div>
        <div class="pull-right">
          <a class="tray-close" @click.prevent="onCloseButtonClick">
            <i class="af-icons af-icons-cross"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="tray-content">
      <div
        ref="trayOverflow"
        class="tray-overflow"
        :style="{ maxHeight: maxHeight, overflowY: overflowY }"
      >
        <slot :scroll-to-top="scrollToTop" :buttons-fixed="buttonsFixed"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jQuery';
import _ from 'underscore';
import Vue from 'vue';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      buttonsFixed: false,
      maxHeight: 'none',
      overflowY: 'visible',
      debouncedOnResize: null
    };
  },
  watch: {
    isOpen() {
      document.body.classList.contains('has-tray')
        ? document.body.classList.remove('has-tray')
        : document.body.classList.add('has-tray');

      Vue.nextTick(() => {
        this.onResize();
      });
    }
  },
  mounted() {
    $(document).one('pjax:error', this.destroy);
    $(document).one('pjax:start', this.destroy);

    this.debouncedOnResize = _.debounce(this.onResize, 100);

    $(window).on('resize', this.debouncedOnResize);
  },
  beforeDestroy() {
    $(window).off('resize', this.debouncedOnResize);
  },
  methods: {
    onCloseButtonClick() {
      this.$emit('beforeClose');
      this.close();
    },
    close() {
      this.$emit('update:isOpen', false);
    },
    destroy() {
      this.close();

      document.body.classList.remove('has-tray');

      Vue.nextTick(() => {
        const oldTarget = document.getElementById('filtertron-tray');
        const newTarget = document.createElement('div');

        newTarget.setAttribute('id', 'filtertron-tray');

        document.body.replaceChild(newTarget, oldTarget);
      });
    },
    onResize() {
      const maxHeight = document.documentElement.clientHeight - 100;
      const overflowHeight = this.buttonsFixed
        ? this.$refs.trayOverflow.scrollHeight
        : this.$refs.trayOverflow.scrollHeight - 50;

      if (maxHeight > overflowHeight) {
        this.buttonsFixed = false;
        this.maxHeight = 'none';
        this.overflowY = 'visible';
      } else {
        this.buttonsFixed = true;
        this.maxHeight = maxHeight + 'px';
        this.overflowY = 'auto';
      }
    },
    scrollToTop() {
      setTimeout(() => (this.$refs.trayOverflow.scrollTop = 0), 100);
    }
  }
};
</script>
